export interface Color {
  Alpha: number;
  Blue: number;
  Green: number;
  Red: number;
}

export interface InteractionConfig {
	picSrc?: string;
	audioSrc: string;
	sender: string;
	soundBiteName: string;
	settings?: {
		Volume: number
		HideSoundbiteVisuals?: boolean
	}
	IconColor: {
		Red: number
		Green: number
		Blue: number
		Alpha: number
	}
	BorderColor: {
		Red: number
		Green: number
		Blue: number
		Alpha: number
	}
	BackgroundColor: {
		Red: number
		Green: number
		Blue: number
		Alpha: number
	}
	FontColor: {
		Red: number
		Green: number
		Blue: number
		Alpha: number
	}
	overlaySettings?: {
    Popup?: {
      BackgroundColor: Color;
      BorderColor: Color;
      FontColor: Color;
      IconColor: Color;
    };
  };
	Size: "s" | "m" | "l"
	timeout?: number; // time after which the interaction gets hidden - in ms
}

export function validateConfig(c: InteractionConfig): boolean {
	if (!c) {
		return false;
	}
	if (!c.timeout) {
		c.timeout = Number(new URLSearchParams(window.location.search).get('timeout') || '200000');
	}
	return true;
}
